
export const ECONOMY_SAVINGS_MESSAGE_TEMPLATES = {
    THIS_YEAR_APPLIED_SAVINGS: gettext('This year applied savings is :savings'),
    LAST_12_MONTHS_APPLIED_SAVINGS: gettext('Last 12 months applied savings is :savings'),
    THIS_DAY_POTENTIAL_SAVINGS: gettext('Today potential savings is :savings'),
};

export const ECONOMY_SAVINGS_METRICS_CONFIG = {
    savings: {
        label: gettext('Savings'),
        value: 'savings',
        type: 'integer',
    },
};
